import { render, staticRenderFns } from "./WindowPaneDimensions.vue?vue&type=template&id=15080b2b"
import script from "./WindowPaneDimensions.vue?vue&type=script&lang=ts"
export * from "./WindowPaneDimensions.vue?vue&type=script&lang=ts"
import style0 from "./WindowPaneDimensions.vue?vue&type=style&index=0&id=15080b2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports